import api from './api';

// GET all partners with certification types
// (ADMIN gets full control in the UI; MEMBER gets read-only — same endpoint, UI decides what to render)
export const getAllPartners = async () => {
  const res = await api.get('/partners');
  return res.data; // partners[] with nested certificationTypes[]
};

// ADMIN ONLY — enforced server-side too, this just mirrors the routes
export const createPartner = async (payload) => {
  const res = await api.post('/partners', payload);
  return res.data;
};

export const updatePartner = async (id, payload) => {
  const res = await api.patch(`/partners/${id}`, payload);
  return res.data;
};

export const deletePartner = async (id) => {
  const res = await api.delete(`/partners/${id}`);
  return res.data;
};

// Certification types (the catalog of certs a partner offers) — ADMIN ONLY
export const createCertificationType = async (partnerId, payload) => {
  const res = await api.post(`/partners/${partnerId}/certification-types`, payload);
  return res.data;
};

export const updateCertificationType = async (id, payload) => {
  const res = await api.patch(`/partners/certification-types/${id}`, payload);
  return res.data;
};

export const deleteCertificationType = async (id) => {
  const res = await api.delete(`/partners/certification-types/${id}`);
  return res.data;
};